/**
 * El contrato HTTP de la creación de sala.
 *
 * Vive en el paquete compartido por el principio II: si el navegador y el servidor tuvieran cada
 * uno su propia idea de la forma de esta petición, la divergencia aparecería como un 400 en el
 * aula, no como un error de compilación.
 */
import { z } from 'zod';
export const createGameRequestSchema = z.object({ quizId: z.uuid() });
export const createGameResponseSchema = z.object({
    gameId: z.uuid(),
    pin: z.string().regex(/^[0-9]{4}$/),
    title: z.string(),
});
/**
 * El cuestionario congelado de una partida, para el informe.
 *
 * Va por el servidor y no por PostgREST **a propósito**, y no es un rodeo: `games.quiz_snapshot`
 * está revocado para el rol `authenticated`, y con razón —dentro están las respuestas correctas,
 * que estuvieron a un `select` de distancia desde la consola del navegador—. Los privilegios de
 * columna son por ROL, y `authenticated` es el rol de toda persona con sesión: alumna, profesora y
 * quien administra por igual. Lo que distingue a la profesora es RLS, que decide filas, no
 * columnas. Así que la revocación pensada para el alumno dejaba también a la profesora sin poder
 * abrir el informe de su propia partida: no cargaba para nadie.
 *
 * Aquí lo lee el servidor con `service_role` y comprueba a mano quién pregunta, que es la única
 * forma de dar el dato a quien le corresponde sin dárselo a todo el mundo.
 */
export const gameSnapshotResponseSchema = z.object({
    snapshot: z.unknown(),
});
//# sourceMappingURL=http-contract.js.map